const configuration = {
  versao: window.env.REACT_APP__VERSION,
  isCordova: !!window.cordova,
  piwiki: window.env.REACT_APP__PIWIKI,
  ambiente: window.env.REACT_APP__AMBIENTE,
  baseUrl: window.env.REACT_APP__BASE_URL,
  urlApi: window.env.REACT_APP__URL_API,
  captchaSiteKey: window.env.REACT_APP__CAPTCHA_SITE_KEY,
  gateway: {
    loginUrl: window.env.REACT_APP__GATEWAY_LOGIN_URL,
    requestCookieUrl: window.env.REACT_APP__GATEWAY_REQUEST_COOKIE_URL,
    logoutUrl: window.env.REACT_APP__GATEWAY_LOGOUT_URL,
    govbrPostLogoutRedirectUrl: window.env.REACT_APP__GOVBR_POST_LOGOUT_REDIRECT_URL,
  },
  device:{
    platform: window.env.REACT_APP__PLATFORM
  },
  oracleInfinityUrl: window.env.REACT_APP__ORACLE_INFINITY_URL,
};

export default configuration;
